// src/App.tsx
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';

import Auth from './routes/Auth/Auth';
import PageLinks from './routes/PageLinks/PageLinks';
import Profile from './routes/Profile/profile';
import LegalTerms from './routes/LegalTerms/LegalTerms';
import AccountSettings from './routes/AccountSettings/AccountSettings';
import Footer from './components/Footer';
import PaymentMethods from './routes/PaymentMethods/PaymentMethods';
import AddCardScreen from './routes/AddCardScreen/AddCardScreen';
import WithdrawalMethods from './routes/WithdrawalMethods/WithdrawalMethods';
import PropertyDetails from './routes/PropertyDetails/PropertyDetails';
import OrderReview from './routes/OrderReview/OrderReview';
import MyProperties from './routes/MyProperties/MyProperties';
import Leaderboard from './routes/Leaderboard/Leaderboard';
import SellReview from './routes/SellReview/SellReview';
import MyBidsPage from './routes/MyBidsPage/MyBidsPage';
import BidReview from './routes/BidReview/BidReview';
import AddPayoutCards from './routes/AddPayoutCards/AddPayoutCards';
import WithdrawalsPage from './routes/WithdrawalsPage/WithdrawalsPage';
import MenuScreen from './routes/home/MenuScreen';
import ShopHome from './routes/Store/ShopHome';
import ProductPage from './routes/Store/ProductPage';
import Return from './routes/Store/Return';
import CheckoutForm from './routes/Store/CheckoutForm';
import ForgotPassword from './routes/ForgotPassword/ForgotPassword';
import ResetPassword from './routes/ResetPassword/ResetPassword';

function App() {
  const token = localStorage.getItem('token');
  const location = useLocation();
  function StaticRedirect() {
    React.useEffect(() => {
      window.location.replace("/cesium-maps_wew_without_data_with_popup.html");
    }, []);
    return null;
  }
  return (
    <div className="main-container">
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flex: 1,
          flexDirection: 'column',
        }}
      >
        <Routes>
          <Route path="/privacy" element={<PageLinks />} />
          <Route path="/terms" element={<PageLinks />} />
          <Route path="/eula" element={<PageLinks />} />
          <Route path="/disclaimer" element={<PageLinks />} />
          {token ? (
            <>
              <Route path="*" element={<Navigate to="/cesium-maps_wew_without_data_with_popup.html" replace />} />
              <Route
                path="/cesium-maps_wew_without_data_with_popup.html"
                element={<StaticRedirect />}
              />
              <Route path="/privacy" element={<PageLinks />} />
              <Route path="/terms" element={<PageLinks />} />
              <Route path="/eula" element={<PageLinks />} />
              <Route path="/disclaimer" element={<PageLinks />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/legal" element={<LegalTerms />} />
              <Route path="/Account-settings" element={<AccountSettings />} />
              <Route path="/Payment-Methods" element={<PaymentMethods />} />
              <Route path="/Add-Card" element={<AddCardScreen />} />
              <Route path="/withdrawal-methods" element={<WithdrawalMethods />} />
              <Route path="/Property-Details" element={<PropertyDetails />} />
              <Route path="/order-review" element={<OrderReview />} />
              <Route path="/sell-review" element={<SellReview />} />
              <Route path="/assets" element={<MyProperties />} />
              <Route path="/Leader-board" element={<Leaderboard />} />
              <Route path="/bids" element={<MyBidsPage />} />
              <Route path="/bid-review" element={<BidReview />} />
              <Route path="/Add-payout-card" element={<AddPayoutCards />} />
              <Route path="/Withdrawl" element={<WithdrawalsPage />} />
              <Route path="/shop" element={<ShopHome />} />
              <Route path="/product/:id" element={<ProductPage />} />
              <Route path="/checkout" element={<CheckoutForm />} />
              <Route path="/return" element={<Return />} />

            </>
          ) : (
            <>
              {/* <Route path="/login" element={<Navigate to="/login" replace />} /> */}
              <Route path="/login" element={<Auth />} />
              <Route path="/signup" element={<Auth />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              {/* <Route path="*" element={<Navigate to="/login" replace />} /> */}


              {/* z */}
              <Route path="/" element={<MenuScreen />} />
              <Route path="/shop" element={<ShopHome />} />
              <Route path="/product/:id" element={<ProductPage />} />
              <Route path="/checkout" element={<CheckoutForm />} />
              <Route path="/return" element={<Return />} />
            </>
          )}
        </Routes>

      </div>
    </div>
  );
}

export default App;
